import { render, staticRenderFns } from "./MSIHeaderDropdownAccnt.vue?vue&type=template&id=0c54e850&"
import script from "./MSIHeaderDropdownAccnt.vue?vue&type=script&lang=js&"
export * from "./MSIHeaderDropdownAccnt.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports